// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7h7JS","left":"styles_left__188gx"};